import GoodInfo from "@/views/GoodInfo";
import Goods from "@/views/Goods";
import Introduction from "@/views/Introduction";
import NewInfo from "@/views/NewInfo";
import News from "@/views/News";
import notFind from "@/views/notFind";
import Qualification from "@/views/Qualification";
import QualificationInfo from "@/views/QualificationInfo";
import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [

    {
        path: '',
        name: 'Home',
        component: Home
    },
    {
        path: '/introduction.html',
        name: 'Introduction',
        component: Introduction
    },
    {
        path: '/goods/:id',
        name: 'Goods',
        component: Goods
    },
    {
        path: '/goodInfo/:id',
        name: 'GoodInfo',
        component: GoodInfo
    },
    {
        path: '/newsInfo/:id',
        name: 'NewInfo',
        component: NewInfo
    },
    {
        path: '/news.html',
        name: 'News',
        component: News
    },
    {
        path: '/qualificationInfo/:id',
        name: 'QualificationInfo',
        component: QualificationInfo
    },
    {
        path: '/qualification.html',
        name: 'Qualification',
        component: Qualification
    },
    {
        path: '/about.html',
        name: 'About',
        component: About
    },
    {
        path: '*',
        name: '404',
        component: notFind
    },

]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
